import React from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';
import SelectForm from '../SelectForm';
import SelectMultiForm from '../SelectMultiForm';
import InputMultiImage from '../imagenes_multi_componente/InputMultiImage';
import useCanchasStore from '../../store/canchasStore';

const FormCanchas = () => {
    const {
        datos,
        sucursales,
        multiImagenes,
        handleChangeImagen,
        handleChange,
        handleSave,
        handleSucursales,
        handleActivo,
        construcciones,
        isLoading,
        error
    } = useCanchasStore();
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="nombre"
                        label="Nombre"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <SelectForm
                        col="col-sm-6"
                        name='construccion'
                        label='Construcción'
                        datos={datos}
                        change={handleChange}
                        error={error}
                        options={construcciones}
                        required
                    />
                    <InputForm
                        col="col-sm-6"
                        name="tiempoUso"
                        label="Tiempo de uso (minutos)"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        esNumero
                    />
                    <SelectMultiForm
                        col="col-sm-12"
                        datos={sucursales}
                        change={handleSucursales}
                        values={datos.sucursales}
                        placeholder="Seleccione una sucursal"
                        name="sucursales"
                        isMulti={false}
                        error={error}
                        required
                    />
                    <InputMultiImage
                        label="Imagen"
                        multiImagenes={multiImagenes}
                        handleChangeImagen={handleChangeImagen}
                        name="multiImagenes"
                        errores={error}
                        maxImages={1}
                    />
                    <div className="form-switch switch-primary d-flex align-items-center gap-2 mt-2 mx-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="activo"
                            checked={Boolean(datos.activo)}
                            onChange={handleActivo}
                        />
                        <label className="form-check-label line-height-1 fw-medium text-secondary-light" htmlFor="activo">
                            Activo
                        </label>
                    </div>
                    
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <div>
                            <button
                                onClick={goBack}
                                type="reset"
                                className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                            >
                                Cancelar
                            </button>
                        </div>
                        <button
                            disabled={Boolean(isLoading.guardarCancha)}
                            onClick={handleSave}
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormCanchas;
